
function findParentByClass(element, className) {
    let currentElement = element;
    
    while (currentElement) {
        if (currentElement.classList.contains(className)) {
            return currentElement;
        }
        
        currentElement = currentElement.parentElement;
    }
    
    return null;
}

function parallaxController(){
    var parallaxElement = document.querySelectorAll(".parallax-image");
    
    if (parallaxElement.length) {
        parallaxElement.forEach(el => {
            $slicked = findParentByClass(el, "slick-row");
            if ( $slicked == null ) {
                var elementSizing = el.getBoundingClientRect();
                var imgWidth = el.dataset.imageWidth;
                var imgHeight = el.dataset.imageHeight;
                var imageHxwRatio =  imgHeight / imgWidth;
                var imageWxhRatio =  imgWidth / imgHeight;
                var elementWxHRatio = elementSizing.width / elementSizing.height;
        
                var newImgHeight = "";
                var newImgWidth = "";
                var alignAdjust = "";
        
                if (elementWxHRatio >= imageWxhRatio) {
                    newImgWidth = elementSizing.width * 1.10;
                    newImgHeight = newImgWidth * imageHxwRatio;
                } else {
                    newImgHeight = elementSizing.height * 1.10;
                    newImgWidth = newImgHeight * imageWxhRatio;
                }
        
                alignAdjust = (newImgHeight - elementSizing.height) / 2; 
                el.style.backgroundAttachment = "fixed";
                el.style.backgroundSize = `${newImgWidth}px ${newImgHeight}px`;
                el.style.backgroundPosition = `center -${alignAdjust}px`;
            }
        });
    }
}

function parallaxShowcase(){
    var showcases = document.querySelectorAll(".parallax-showcase");
    if ( showcases.length) {
        showcases.forEach(showcase => {
            var images = showcase.getAttribute("data-parallax-images");
            var transitionDelay = 750;
            var transitionDuration = parseInt(showcase.getAttribute("data-transition-duration"));
            images = images.split(",");
            if (images.length <= 1) {
                showcase.style.backgroundImage = `url(${images[0]})`;
            } else {
                var index = 1;
                showcase.style.backgroundImage = `url(${images[0]})`;
                var imageChange = setInterval(function(){
                    showcase.style.opacity = "0";
                    setTimeout(function(){
                        showcase.style.backgroundImage = `url(${images[index]})`;
                        showcase.style.opacity = "1";
                    },transitionDelay);
                    if (images.length == index + 1) {
                        index = 0;
                    } else {
                        index++;
                    }
                }, (transitionDuration * 1000) + transitionDelay);
            }
        });
    }
}

parallaxController();
parallaxShowcase();

window.onresize = function(){
    parallaxController();
};